import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MobileFilledSvg from "@ant-design/icons-svg/es/asn/MobileFilled";
import AntdIcon from "../components/AntdIcon";
var MobileFilled = function MobileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MobileFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MobileFilled.displayName = 'MobileFilled';
}
export default /*#__PURE__*/React.forwardRef(MobileFilled);